import React from 'react';
import {
	Stack,
	Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';

import { errorsSelector } from '../store/errors';


// errorList

function Errors() {
  const errorList = useSelector(errorsSelector);
  return (
    <Stack spacing={1}>
    	{errorList.map((error, index) => (<Typography
    		variant="overline"
    		sx={{ color: 'error.main', textAlign: 'center', mt: 1, fontWeight: 500 }}
		>
			Error {index + 1}: {JSON.stringify(error)}
		</Typography>))}
    </Stack>
  );
}

export default Errors;